import React from 'react';

export default function UncheckedRedIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill="#F0F0F0" />
      <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" stroke="#CCCCCC" />
    </svg>
  );
}
